import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function OfferCalendarRoomModal() {
  const { resolve } = useModalElementContext()
  const intl = useIntl()

  const onRoomSelect = useCallback(() => {
    resolve?.()
  }, [resolve])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'AhbkLosb-bGqbtB7aikL',
        defaultMessage: 'Rooms',
      })}
      primaryActionText={intl.formatMessage({
        id: 'qr_dyO1wCZQYmGOSiQ_z',
        defaultMessage: 'Apply',
      })}
    >
      <OfferCalendarRoomOptions onSelect={onRoomSelect} />
    </Modal>
  )
}

export default OfferCalendarRoomModal
